import React, { Component } from 'react';
import { NavLink } from 'react-router-dom';
import FontAwesomeIcon from '@fortawesome/react-fontawesome';

class HeaderNav extends Component {
  render() {
    return (
      <ul className="HeaderNav">
        <li className="HeaderNav__item">
          <NavLink
            to="/"
            exact
            activeClassName="active"
            className="HeaderNav__item-link"
          >
            <FontAwesomeIcon
              icon={["far", "tachometer"]}
            />
            <span>Dashboard</span>
          </NavLink>
        </li>
        <li className="HeaderNav__item">
          <NavLink
            to="/tests"
            exact
            activeClassName="active"
            className="HeaderNav__item-link"
          >
            <FontAwesomeIcon
              icon={["far", "flask"]}
            />
            <span>Tests</span>
          </NavLink>
        </li>
        <li className="HeaderNav__item">
          <NavLink
            to="/clients"
            exact
            activeClassName="active"
            className="HeaderNav__item-link"
          >
            <FontAwesomeIcon
              icon={["far", "users"]}
            />
            <span>Clients</span>
          </NavLink>
        </li>
        <li className="HeaderNav__item">
          <NavLink
            to="/reports/state"
            activeClassName="active"
            className="HeaderNav__item-link"
            isActive={(match, { pathname }) => pathname.match('/reports')}
          >
            <FontAwesomeIcon
              icon={["far", "chart-bar"]}
            />
            <span>Reports</span>
          </NavLink>
        </li>
        <li className="HeaderNav__item">
          <NavLink
            to="/qa/crm/duplicates"
            activeClassName="active"
            className="HeaderNav__item-link"
            isActive={(match, { pathname }) => pathname.match('/qa')}
          >
            <FontAwesomeIcon
              icon={["far", "shield-check"]}
            />
            <span>QA</span>
          </NavLink>
        </li>
      </ul>
    );
  }
}

export default HeaderNav;



// WEBPACK FOOTER //
// ./src/components/layouts/LoggedIn/Header/HeaderNav.js